// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".site__footer-logo{align-items:center;display:inline-flex;padding:3px 6px;text-decoration:none}.site__footer-logo,.site__footer-logo:focus,.site__footer-logo:hover{color:var(--p-text-color)}.path-1{fill:var(--p-logo-fill)}.path-2{fill:var(--p-logo-fill-2)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
